import AcademicGrowth from './AcademicGrowth.component';

export default AcademicGrowth;
